import React from "react";
import NutrientIcons from "./NutrientIcons";

export type iconName =
  | "chevron down"
  | "chevron up"
  | "chevron right"
  | "chevron left"
  | "arrow left"
  | "arrow right"
  | "sort"
  | "columns"
  | "list"
  | "table"
  | "more vertical"
  | "more horizontal"
  | "filter"
  | "search"
  | "zoom"
  | "add-plus"
  | "remove-minus"
  | "reset"
  | "warning"
  | "error"
  | "check circle"
  | "edit"
  | "draw"
  | "cut"
  | "measure"
  | "merge or group"
  | "select"
  | "link"
  | "unlink"
  | "attachment"
  | "download"
  | "upload"
  | "user"
  | "user add"
  | "user edit"
  | "contacts"
  | "customers"
  | "supplier"
  | "inventory"
  | "farm"
  | "machines"
  | "dashboard"
  | "weather"
  | "contracts"
  | "admissions"
  | "disease"
  | "planning"
  | "storage-location"
  | "test-location"
  | "soiltest"
  | "calendar edit"
  | "calendar"
  | "fumigation"
  | "tillage"
  | "preparation"
  | "planting"
  | "fertilisation"
  | "protection"
  | "irrigation"
  | "observation"
  | "password hide"
  | "harvesting"
  | "information circle"
  | "question circle"
  | "close"
  | "map"
  | "location pinpoint"
  | "location marker"
  | "notifications"
  | "hamburger"
  | "language"
  | "logout"
  | "cropfields"
  | "cropfields add"
  | "mail"
  | "check"
  | "spinner"
  | "harvesting"
  | "clock"
  | "calendar day"
  | "delete"
  | "danger"
  | "cloudfarm"
  | "chevron circle left"
  | "chevron circle right"
  | "extension"
  | "lot"
  | "help"
  | "task"
  | "label"
  | "job"
  | "assign"
  | "dragdrop"
  | "clear"
  | "import-export"
  | "chart-details"
  | "wind"
  | "temperature"
  | "sun"
  | "rain"
  | "humidity"
  | "cloudy"
  | "analysis"
  | "financial"
  | "import"
  | "export"
  | "insects"
  | "settings"
  | "external link"
  | "apps"
  | "simple"
  | "sparkles"
  | "autofill";

export interface IconProperties {
  icon: iconName;
  size?: "" | "fa-xs" | "fa-sm" | "fa-lg" | "fa-2x" | "fa-3x" | "fa-5x" | "fa-7x" | "fa-10x";
  className?: string;
}

const Icon = ({ icon, size = "", className = "" }: IconProperties) => {
  const prefix = NutrientIcons[icon];
  return <i className={`${prefix} ${size} ${className}`} />;
};

export default Icon;
